var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.updates),function(up){return _c('Status',{key:up.date,attrs:{"date":up.date,"message":up.message}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }